export default __webpack_public_path__ + "static/media/contact-header.fed00d18.png";